import { CATEGORY_LABELS } from "../lib/constants";
import { Share2, Check, Mail } from "lucide-react";
import { useState } from "react";

export function ArticleHeader({ article }) {
  const [copied, setCopied] = useState(false);
  const sourceName = article.source_count > 1
    ? `${article.source} +${article.source_count - 1}`
    : article.source;
  const articleUrl = `${window.location.origin}${window.location.pathname}?article=${article.id}`;
  const emailUrl = `mailto:?subject=${encodeURIComponent(article.neutral_title)}&body=${encodeURIComponent(articleUrl)}`;

  const handleShare = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(articleUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    } catch {
      // Clipboard not available
    }
  };

  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <span className="text-xs tracking-[0.2em] uppercase font-mono text-gray-400">
          {CATEGORY_LABELS[article.category] || article.category}
        </span>
        <span className="text-gray-300 dark:text-zinc-700">|</span>
        <span className="text-xs tracking-[0.2em] uppercase font-mono text-gray-400">
          {sourceName}
        </span>
        <div className="ml-auto flex items-center gap-1">
          <a
            href={emailUrl}
            className="p-1.5 rounded-sm text-gray-400 hover:text-[#0A0A0A] dark:hover:text-zinc-50 transition-colors focus:outline-none"
            aria-label="Send artikel med e-mail"
            title="Send med e-mail"
          >
            <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
          </a>
          <button
            onClick={handleShare}
            className="p-1.5 rounded-sm text-gray-400 hover:text-[#0A0A0A] dark:hover:text-zinc-50 transition-colors focus:outline-none"
            aria-label={copied ? "Link kopieret" : "Kopier link til artikel"}
            title={copied ? "Link kopieret!" : "Kopier link"}
          >
            {copied ? <Check className="w-3.5 h-3.5" strokeWidth={1.5} /> : <Share2 className="w-3.5 h-3.5" strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      <h1 className="text-3xl sm:text-4xl lg:text-[2.75rem] tracking-tight font-black leading-tight mb-6 font-['Archivo'] text-[#0A0A0A] dark:text-zinc-100">
        {article.neutral_title}
      </h1>
    </>
  );
}
